import React from 'react'
import { Typography, Input, Row, Col, Form, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader } from '~components'

import DownArrow from '../PositionArrows/DownArrow'
import UpArrow from '../PositionArrows/UpArrow'
import styles from './TourMarketingCard.module.css'

const { Title } = Typography
const { TextArea } = Input
const { Panel } = Collapse

const TourMarketingCard = ({ marketingModules, setMarketingModules, pageType }) => {
  const handleCTANameChange = (event, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      cta: {
        ...modules[index].cta,
        name: event.target.value
      }
    }
    setMarketingModules([...modules])
  }
  const handleSubTxtChange = (event, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      cta: {
        ...modules[index].cta,
        sub_title: event.target.value
      }
    }
    setMarketingModules([...modules])
  }
  const handleNameChange = (event, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      header: event.target.value
    }
    setMarketingModules([...modules])
  }

  const handleCTAUrlChange = (event, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      cta: {
        ...modules[index].cta,
        url: event.target.value
      }
    }
    setMarketingModules([...modules])
  }

  const handleSubtitleChange = ({ target }, index) => {
    const clonedContentCard = [...marketingModules]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      paragraph: target.value
    }
    setMarketingModules([...clonedContentCard])
  }

  const handleMarketingFormIdUpdate = ({ target }, index) => {
    const clonedContentCard = [...marketingModules]
    clonedContentCard[index] = {
      ...clonedContentCard[index],
      formstack_id: target.value
    }
    setMarketingModules([...clonedContentCard])
  }

  const handleImageUrlUpdate = (secureImageURL, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      icon: secureImageURL
    }
    setMarketingModules([...modules])
  }

  const handleIconChange = (imgObj, index) => {
    const modules = [...marketingModules]
    modules[index] = {
      ...modules[index],
      icon: imgObj?.url
    }
    setMarketingModules([...modules])
  }

  const deletePill = (event, index) => {
    event.stopPropagation()
    const modules = [...marketingModules]
    if (index !== -1) {
      modules.splice(index, 1)
    }
    setMarketingModules(modules)
  }

  const handleMoveUp = (event, id) => {
    event.stopPropagation()
    const tempList = [...marketingModules]
    if (id > 0) {
      const el = tempList[id]
      tempList[id] = tempList[id - 1]
      tempList[id - 1] = el
      setMarketingModules([...tempList])
    }
  }

  const handleMoveDown = (event, id) => {
    event.stopPropagation()
    const tempList = [...marketingModules]
    if (id !== -1 && id < tempList.length - 1) {
      const el = tempList[id]
      tempList[id] = tempList[id + 1]
      tempList[id + 1] = el
      setMarketingModules([...tempList])
    }
  }

  return (
    <div className={styles['marketing-pill-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {marketingModules?.map((marketingModule, rowIndex) => (<Panel key={rowIndex} extra={<Row gutter={2}><Space>
          <Col align="left" span={4}>
            <Row gutter={[10]} style={{ width: '60px' }}>
              {rowIndex !== 0 && <Col align='right' data-testid="up-arrow" onClick={(event) => handleMoveUp(event, rowIndex)} span={12}>
                <UpArrow />
              </Col>
              }
              {marketingModules?.length - rowIndex !== 1
                ? <Col align="left" data-testid="down-arrow" onClick={(event) => handleMoveDown(event, rowIndex)} span={12}>
                  <DownArrow/>
                </Col>
                : <Col span={3} />}
            </Row>
          </Col>
          <Button danger onClick={(event) => deletePill(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
        </Space>
        </Row>
        } header={<span style={{ fontSize: 20 }}>{marketingModule?.header}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Label</Title></Col>
            <Col>(70 characters max)</Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input maxLength={70} onChange={(event) => handleNameChange(event, rowIndex)} value={marketingModule?.header}/></Form.Item>
            </Col>
          </Row>
          <br />
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Icon</Title></Col>
            <Col><Title level={4}> (Upload PNG or JPG; preferred dimensions 0px x 0px; max file size 1MB)</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <ImageUploader handleIconChange ={(imageObj) => handleIconChange(imageObj, rowIndex)} handleUpload={(url) => handleImageUrlUpdate(url, rowIndex)} logoUrl={marketingModule?.icon} pageType={pageType} />
            </Col>
          </Row>
          <br/>
          <>
            <Row align={'left'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Paragraph Text</Title></Col>
            </Row>
            <Row>
              <TextArea
                autoSize={{ minRows: 2 }}
                maxLength={155}
                onChange={(e) => handleSubtitleChange(e, rowIndex)}
                style={{ width: '100%' }}
                value={marketingModule?.paragraph}
              />
            </Row>
            <br />
            <Row align={'left'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Formstack Id</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item><Input onChange={(event) => handleMarketingFormIdUpdate(event, rowIndex)} value={marketingModule?.formstack_id}/></Form.Item>
              </Col>
            </Row>
            <br />
            <Row align={'left'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Call-to-Action Label</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item><Input onChange={(event) => handleCTANameChange(event, rowIndex)} value={marketingModule?.cta?.name}/></Form.Item>
              </Col>
            </Row>
            <br />
            <Row align={'left'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Call-to-Action Sub_Text</Title></Col>
            </Row>
            <Row>
              <Form.Item><Input maxLength={70} onChange={(event) => handleSubTxtChange(event, rowIndex)} value={marketingModule?.cta?.sub_title}/></Form.Item>
            </Row>
            <br />
            <Row align={'left'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Call-to-Action URL</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item><Input onChange={(event) => handleCTAUrlChange(event, rowIndex)} value={marketingModule?.cta?.url}/></Form.Item>
              </Col>
            </Row>
          </>
        </Panel>))
        }
      </Collapse>
    </div>
  )
}

TourMarketingCard.propTypes = {
  marketingModules: PropTypes.array,
  pageType: PropTypes.string,
  setMarketingModules: PropTypes.func
}

export default TourMarketingCard
